import SimpleBreadcrumbs from "@/modules/pages/components/simple-breadcrumbs/index.vue"
import ComsobaseLessonActions from "./components/actions/index.vue";
import ComsobaseLessonInfo from "./components/info/index.vue"
import { mapActions, mapGetters } from "vuex";
import { globalLoader } from "../../../helpers/variables";

export default {
    name: "CosmobaseLessonPage",
    props: {},
    emits: [],
    components: {
      SimpleBreadcrumbs,
      ComsobaseLessonActions,
      ComsobaseLessonInfo
    },
    setup() {},
    data() {
        return {}
    },
    async created() {
      globalLoader(true)
      await Promise.all([
        this.getWebinarsById(this.$route.params.id)
      ])
      globalLoader(false)
    },
    mounted() {},
    watch: {},
    computed: {
      ...mapGetters({
        content: "cosmobase/webinar",
      })
    },
    methods: {
      ...mapActions({
        getWebinarsById: "cosmobase/GET_WEBINARS_BY_ID"
      }),
    }
}